import React from "react";
import { Pressable, StyleSheet, TouchableOpacity, } from 'react-native';
import { Octicons, FontAwesome, Ionicons, } from '@expo/vector-icons';

import { Text, View } from '../../../components/Themed';
import Utilities from '../~Utilities/Utilities';
import Text2 from '../C_Text/Text2';
import Dots from '../C_General/Dots';
import QB from './QB';
import OB from './OB';
import ORD from './ORD';

import { Data, PosData } from "../~Utilities/Data";
import Order from "../C_Popups/SettingsAndOrders";
import { ScrollView } from "react-native-gesture-handler";
import { ConnectionMkt, ConnectionOrd } from "../~Utilities/Connection";
import { AppMain, EvtData, FontInfo } from "../~Utilities/Constants";
import EVT from "./EVT";
import BlackHeader from "../C_Text/BlackHeader";

/*   ---------------------------------------------------------------------   */

export interface ISymbolInfo
{
  oData     : Data;
  Remove    : (sToken: string)=>void;
  bindEvent : (onEvent    : (() => void), 
               bSubscribe : boolean) => void
}

/*   ====================================================================   */

export default class SymbolInfo extends React.Component<ISymbolInfo> 
  {
  scrollRef                         : ScrollView | null = null;
  dotRef                            : Dots | null  = null;
  obRef                             : OB | null    = null;
  qbRef?                            : React.RefObject<QB>;//QB | null    = null;
  ordRef                            : ORD | null   = null;
  evtRef                            : EVT | null   = null;
  oOrderRef                         : Order | null = null;
  headerRef                         : BlackHeader | null = null;
  curr_page                         : number             = 0;
  private oEvtData?                 : EvtData;
  private iSettIndex                : number             = 0;

  //currRef                           : React.RefObject<number>;
  
  /*   -------------------------------------------------------------------   */

  constructor(props)
  {
  super(props);

  this.state        = {b_available:true,
                      index:0
                      };

  this.onSelectAccount   = this.onSelectAccount.bind(this);
  this.dotClicked        = this.dotClicked.bind(this);
  this.UpdateEvtData     = this.UpdateEvtData.bind(this);
  this.GetBlackText      = this.GetBlackText.bind(this);
  this.GetBlackTextAddl  = this.GetBlackTextAddl.bind(this);
  this.onSubOB           = this.onSubOB.bind(this);

  //this.curr_page = this.props.oData.curr_page;
  this.qbRef     = React.createRef();

  //this.currRef = React.createRef();
  //this.currRef = 0;

  //if (this.props.oData.obo_visible == true)
    //Utilities.Sendlog("OB open: " + this.props.oData.token);
  //if this.props.oData
  //this.props.oData.obo_visible = false;
  //Utilities.Sendlog("Un")

  let z = Utilities.FindItem(ConnectionOrd.oSettings, this.props.oData.token);

  if (z != AppMain.IMAGINARY)
    this.iSettIndex = z;

  //this.oEvtData = ConnectionMkt.GetEvtData(this.props.oData);

  if (this.props.oData.evt_exp   && 
      this.props.oData.evt_index < this.props.oData.evt_exp.length)
    {
    this.oEvtData = this.props.oData.evt_exp[this.props.oData.evt_index];

    // if (__DEV__)    
    //   Utilities.Sendlog("Setting event data ctr..." + this.oEvtData?.sUSymbol);
    }
  }

  /*   -------------------------------------------------------------------   */

  //New_EVT
  UpdateEvtData_Old(oEvtData : EvtData)
  {
  if (__DEV__)    
    Utilities.Sendlog("Setting event data...");
  
  if (this.oEvtData)
    return;

  if (this.props.oData.token           == oEvtData.sToken ||
      (this.props.oData.bContSymbol    && 
       this.props.oData.trading_symbol == oEvtData.sUSymbol))
  //if (this.props.oData.evt_org_token == this.props.oData.token)
        {
        if (__DEV__)          
          Utilities.Sendlog("Setting event data: " + oEvtData.sToken);

        this.oEvtData = oEvtData;

        this.evtRef?.Refresh(oEvtData);
        this.evtRef?.Show();

        this.dotRef?.SetEvt(true);

        //if (this.props.oData.evt_org_token == this.props.oData.token)
          //this.dotClicked(3, true, true);

        this.qbRef?.current?.oEvtLink?.Show();
        }
  }

  /*   -------------------------------------------------------------------   */

  UpdateEvtAvbl(oData : Data)
  {
  if (__DEV__)    
    Utilities.Sendlog("Setting event data...");
  
  if (this.props.oData.token           == oData.token)
      {
      if (__DEV__)        
        Utilities.Sendlog("Setting event data avbl: " + oData.token);

      this.evtRef?.Show();
      this.dotRef?.SetEvt(true);

      if (AppMain.bEventTradeAdv)
        this.qbRef?.current?.oEvtLink?.Show();
      }
  }

  /*   -------------------------------------------------------------------   */

  UpdatePositionData(oData : Data)
  {
  if (oData.token == this.props.oData.token && oData.bContSymbol == true)
    {
    if (__DEV__)      
      Utilities.Sendlog("Updating position data on ref data arrival...");

    let sAccKey = this.ordRef?.state.pos_data?.acc_key;
    let sToken;

    if (oData.trading_symbol && oData.trading_exchange)
      sToken = oData.trading_symbol + "." + oData.trading_exchange;

    /*   -----------------------------------------------------------------   */

    if (sAccKey != undefined && sToken != undefined)
      {
      if (this.ordRef?.state.pos_data?.token == sToken)
        return;
  
      let sKey     = sAccKey + sToken;
      let oPosData = ConnectionOrd.oPosStore.get(sKey);

      /*   ---------------------------------------------------------------   */
                
      if (oPosData == undefined)
        {
        oPosData = new PosData(sAccKey, sToken);
        ConnectionOrd.oPosStore.set(sKey, oPosData);
        }

      /*   ---------------------------------------------------------------   */
      
      this.ordRef?.SelectAccount(oPosData);
      this.qbRef?.current?.oChartRef?.SelectAccountForce(oPosData);
      this.qbRef?.current?.oOrderRef?.ChangeAccountForce(oPosData);
      this.obRef?.SelectAccountForce(oPosData);
      this.obRef?.obBottom?.orderWoOrderRef?.SelectAccountForce(oPosData);
      this.evtRef?.SelectAccount(oPosData);
      }
    }
  }

  /*   -------------------------------------------------------------------   */

  UpdateEvtAdv()
  {
  if (__DEV__)    
    Utilities.Sendlog("Updating event trade adv...");
  
  if (this.props.oData.is_evt_enabled)
      {
      if (AppMain.bEventTradeAdv)
        this.qbRef?.current?.oEvtLink?.Show();
      else
        this.qbRef?.current?.oEvtLink?.Hide();
      }
  }

  /*   -------------------------------------------------------------------   */

  UpdateChart()
  {
  this.qbRef?.current?.oChartRef?.forceUpdate(); //UpdateData();
  }

  /*   -------------------------------------------------------------------   */

  //New_EVT
  UpdateEvtData(oEvtData : EvtData)
  {
  if (__DEV__)    
    Utilities.Sendlog("Setting event data...");
  
  if (this.oEvtData)
    return;

  if (this.props.oData.token           == oEvtData.sToken ||
      (this.props.oData.bContSymbol    && 
       this.props.oData.trading_symbol == oEvtData.sUSymbol))
  //if (this.props.oData.evt_org_token == this.props.oData.token)
        {
        if (__DEV__)
          Utilities.Sendlog("Setting event data: " + oEvtData.sToken);

        this.oEvtData = oEvtData;

        this.evtRef?.Refresh(oEvtData);
        //this.evtRef?.Show();

        //this.dotRef?.SetEvt(true);

        //if (this.props.oData.evt_org_token == this.props.oData.token)
          //this.dotClicked(3, true, true);

        //this.qbRef?.current?.oEvtLink?.Show();
        }
  }


  /*   -------------------------------------------------------------------   */

  onSelectAccount(oData : PosData)
  {
  this.ordRef?.SelectAccount(oData);
  this.obRef?.obBottom?.orderWoOrderRef?.SelectAccount(oData);
  this.obRef?.SelectAccount(oData);
  this.evtRef?.SelectAccount(oData);
  this.qbRef?.current?.oChartRef?.SelectAccount(oData);
  }

  /*   -------------------------------------------------------------------   */

  onSubOB(oData : Data)
  {
  if (this.props.oData.token         != oData.token || 
      this.props.oData.visible_index != 1)
      return;

  if (!this.obRef || this.obRef.state.visible)
    return;

  let oOBData = ConnectionMkt.GetOB(this.props.oData);

  if (__DEV__)  
    Utilities.Sendlog("book:" + oOBData?.sub_ob);

  if (oOBData != undefined && this.props.oData.trade_got == true)
    {
    this.obRef?.Show();

    this.obRef?.SetCenter(ConnectionMkt.GetOBLevelAlt(this.obRef?.oOBLevels? 
                                                      this.obRef?.oOBLevels[0].Price : 
                                                      undefined, 
                                                      this.props.oData.last,
    
                                                      this.props.oData));

    //if (!this.obRef?.bOBCentered)
      this.obRef?.CenterBook();

    this.obRef?.RefreshOrders();
    }
  }

  /*   -------------------------------------------------------------------   */

  dotClicked(iIndex    : number,
             bScroll   : boolean = true,
             bAnimated : boolean = true) : void
  {
    if (this.curr_page == iIndex)
      {
      if (__DEV__)        
        Utilities.Sendlog("SAME page: " + iIndex);

      return;
      }

    let iPrevPage              = this.curr_page;
    this.curr_page             = iIndex;
    this.props.oData.curr_page = iIndex;

    // if (bScroll == false)
    //   this.headerRef?.UpdateText(this.GetBlackText(iIndex, bScroll), this.GetBlackTextAddl(iIndex));
    //this.forceUpdate();

    if (__DEV__)
      Utilities.Sendlog("***=> page TURNED: " + iIndex + " prev page: " + iPrevPage);


    if (bScroll == true)
      this.scrollRef?.scrollTo({x: iIndex * Utilities.WIDTH, animated:bAnimated});

    if (iIndex == 3)
      {
      if (this.props.oData.is_evt_enabled == true)
        ConnectionMkt.Rq_GetEventContracts(this.props.oData);
      }

    if (iIndex == 1)
      {
      this.props.oData.visible_index = 1;

      let oOBData = ConnectionMkt.SubscribeOB(this.props.oData);

      if (__DEV__)
        Utilities.Sendlog("book:" + oOBData?.sub_ob);

      if (oOBData != null && this.props.oData.trade_got == true)
        {
        this.obRef?.Show();

        this.obRef?.SetCenter(ConnectionMkt.GetOBLevelAlt(this.obRef?.oOBLevels? 
                                                          this.obRef?.oOBLevels[0].Price : 
                                                          undefined, 
                                                          this.props.oData.last,
        
                                                          this.props.oData));

       //if (!this.obRef?.bOBCentered)
          this.obRef?.CenterBook();

        this.obRef?.RefreshOrders();
        }
      }
    else
      {
      // if (iIndex == 3)
      //   this.evtRef?.PageTurned();
6
      if (__DEV__)
        Utilities.Sendlog("****Trying to unsub book. prev page: " + iPrevPage + " curr page: " + this.curr_page);

      //if (iPrevPage == 1)
      if (this.props.oData.visible_index == 1)
        ConnectionMkt.UnSubscribeOB(this.props.oData);

      this.props.oData.visible_index = iIndex;
      }
  }

  /*   -------------------------------------------------------------------   */

  state        = {b_available:true,
                  index:0
                  };

  /*   -------------------------------------------------------------------   */

  GetBlackText(iIndex  : number, 
               bUpdate : boolean)
  {
    if (iIndex == 3 && bUpdate == true)
      {
        return(this.props.oData.product_code + " - Event Trading");
      }
    else
      return(this.props.oData.symbol + "." + this.props.oData.exchange);
  }

  /*   -------------------------------------------------------------------   */

  GetBlackTextAddl(iIndex : number)
  {
    if (iIndex == 3)
      {
      return(""); //Event Contracts
      }
    else
      return("");
  }

  /*   -------------------------------------------------------------------   */

  componentDidMount() {
    // if (this.props.oData.curr_page != this.curr_page)
    //   this.scrollRef?.scrollTo({x: this.props.oData.curr_page * Utilities.WIDTH, animated:false});

  //  if(this.props.oData.obo_visible == true) {
  //     this.scrollRef?.scrollTo({ x:1 * Utilities.WIDTH, y:0, animated:false });
  //   }
  }

  /*   -------------------------------------------------------------------   */

  render() 
  {
  if (this.state.b_available == false)
    return(null);
  else  
  {
  //setAnimation();

  return (
    <View style={[styles.symbol_container_0, { backgroundColor:'transparent' }  ]}>

    {/* BLACK HEADER */}
    

    <View style={[styles.row_header_container, {}]}>
      <Pressable onLongPress={()=>{ConnectionOrd.ShowSearch(this.props.oData.token)}}>

      <BlackHeader ref={node => { this.headerRef = node; } } sText={this.GetBlackText(0, false)} sAddText={this.GetBlackTextAddl(0)} />
      {/* <Text style={[FontInfo.appStyles.txt_black, styles.row_header]}>{
                                              this.dotRef?.state.m_index == 3? 
                                              this.props.oData.trading_symbol? 
                                              this.props.oData.trading_symbol : this.props.oData.symbol
                                              + "." + this.props.oData.exchange :
                                              this.props.oData.symbol + "." + this.props.oData.exchange }</Text> */}
      </Pressable>

      <TouchableOpacity style={{zIndex:100, position:'absolute', left:0, top:0, padding:5, paddingLeft:13, paddingTop:6, alignContent:'center', backgroundColor:'transparent', justifyContent:'center'}} 
          onPress={()=>{this.qbRef?.current?.oOrderRef?.ShowSettings(this.curr_page==3)}}>
      <Ionicons name="md-settings-sharp" style={{alignContent:'center', opacity:1, backgroundColor:'transparent' }} size={16} color={'rgba(125,125,125, 1)'} />
      </TouchableOpacity>

      <TouchableOpacity style={styles.header_close} onPress={()=> {
            this.props.Remove(this.props.oData.token);
            this.setState({b_available:false});
           }}        
         >
      <FontAwesome style={{ /*marginTop:2,*/ alignSelf:'center', /*marginBottom: -3,*/  }} name="close" size={20} color="#d14d4d" />
      </TouchableOpacity>
    </View>

    {/* WHITE BODY */}
   <View style={[styles.symbol_container, {marginTop:-1, backgroundColor:FontInfo.sBackground }]}
   >
   <ScrollView horizontal={true} showsHorizontalScrollIndicator={false} pagingEnabled={true} scrollEventThrottle={60}
    // ref={node => { scrollRef.current = node; }}
    ref={(node : ScrollView)=>{
          this.scrollRef = node;

          // if (this.props.oData.curr_page != this.curr_page)
          //   this.scrollRef?.scrollTo({x: this.props.oData.curr_page * Utilities.WIDTH, animated:false});
        }}

    onScroll={e => {
      var currentIndex = Math.round (e.nativeEvent.contentOffset.x/Utilities.WIDTH);
      //Utilities.Sendlog("y-> " + e.nativeEvent.contentOffset.x + " page: " + currentIndex);

    
      if (this.dotRef?.SetIndex(currentIndex) == true)
        {
        if (__DEV__)          
          Utilities.Sendlog("scroll event");

        this.dotClicked(currentIndex, false);

        this.headerRef?.UpdateText(this.GetBlackText(currentIndex, true), this.GetBlackTextAddl(currentIndex));

        if (currentIndex == 3)
          {
          //this.evtRef?.PageTurned();
          this.evtRef?.GetMktData(true);
          this.qbRef?.current?.oEvtLink?.Hide();
          }
        else
          this.evtRef?.GetMktData(false);
        }
    }}
    >

   <View style={{ backgroundColor: "transparent", flex: 1, width: Utilities.WIDTH }}>
     <QB ref={this.qbRef} oData={this.props.oData} bindEvent={this.props.bindEvent} 
         iSettIndex={this.iSettIndex}
         dotClicked={this.dotClicked}
         onSelectAccount={this.onSelectAccount}/>
   </View>

   <View style={{ backgroundColor: "transparent", flex: 1, width: Utilities.WIDTH }}>
     <OB ref={(node)=> {this.obRef=node}} qbRef={this.qbRef} 
         oData={this.props.oData} bindEvent={this.props.bindEvent}
         iSettIndex={this.iSettIndex}/>
   </View>

   <View style={{ backgroundColor: "transparent", flex: 1, width: Utilities.WIDTH }}>
     <ORD ref={(node)=> {this.ordRef=node}} oData={this.props.oData} bindEvent={this.props.bindEvent}/>
   </View>

   {/* <View style={{ backgroundColor: "transparent", flex: 1, width: Utilities.WIDTH }}> */}
     <EVT ref={(node)=> {this.evtRef=node}}  visible={this.props.oData.is_evt_enabled} qbRef={this.qbRef} oData={this.props.oData} oEvtData={this.oEvtData} bindEvent={this.props.bindEvent}/>
   {/* </View>    */}
    
   </ScrollView>

   {/* <View> */}

   <TouchableOpacity style={{zIndex:100, position:'absolute', left:0, bottom:0, width:50, height:40, borderRadius:20, alignContent:'center', backgroundColor:'transparent', justifyContent:'center'}} onPress={()=>{this.qbRef?.current?.oOrderRef?.ShowSymbolProps()}}>
              <Octicons style={{alignContent:'center', left:20, position:'absolute', bottom:4, opacity:.8, width:20, backgroundColor:'transparent' }} name="three-bars" size={16} color={'slategrey'} onPress={()=>{this.qbRef?.current?.oOrderRef?.ShowSymbolProps()}} />
              {/* <FontAwesome style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -3 }} name="bars" size={12} color={'gainsboro'} /> */}
              {/* <Text style={{backgroundColor:'yellow', color:'red', fontSize:16}}>⚙️</Text> */}
              </TouchableOpacity>

   <View style={{width:'90%', alignSelf:'center', backgroundColor:'transparent'}}>
   <Dots ref={(node)=> {this.dotRef=node}} 
        //  bEvt={this.oEvtData? true : false} 
         bEvt={this.props.oData.is_evt_enabled} 
         clickEvent={this.dotClicked} iIndex={0}
         onBlue={(iIndex:number)=>
                    {
                    // this.headerRef?.UpdateText(this.GetBlackText(iIndex), this.GetBlackTextAddl(iIndex));

                    // if (iIndex == 3)
                    //   this.evtRef?.PageTurned();
                    }}/>

   <Text2 name = "" 
           bbb={this.props.bindEvent} 
           style={[FontInfo.appStyles.txt_normal, styles.row_time, {position:'absolute', backgroundColor:'transparent', minWidth:40, bottom:4, right:0, color:FontInfo.sDivider, textAlign:'right', marginLeft:4}]} 
           ggg={()=>{return((this.props.oData.time != 0? "" : "") + (this.props.oData.msgs != 0? this.props.oData.msgs.toString() : " "))}} 
           />

    </View>           

   </View>
   </View>
  );}
}
}

/*   ====================================================================   */

const styles = StyleSheet.create({
  row_time: {
    color: 'grey',
  },  

  row_header: {
    alignSelf: 'center',
    fontSize: FontInfo.iFontSize + 8,
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
  },

  header_close: {
    alignContent:'center',
    justifyContent:'center',
    width:40,
    height:28,
    position:'absolute',
    right:0,
  },

  row_header_container: {
    height:30,
    flexDirection:'row',
    alignSelf: 'stretch',
    justifyContent: 'center',
    backgroundColor: 'black',//'#04cd25', //'black',//"lightslategrey",

    //borderWidth: 1,
    borderTopRightRadius: 20,
    borderTopLeftRadius: 20,

  },

   symbol_container: {
    //margin: 8,
    //backgroundColor: 'white',
    borderWidth: 0,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    borderColor: 'rgba(255,255,255,0.1)',
  },

  symbol_container_0: {
    alignSelf: 'center',
    margin: 20,
   width:Utilities.WIDTH,
   //flex: 0.5,
   //backgroundColor: 'white',

   borderRadius: 20,
 },

});
